import Select from "react-select";

const SelectYear = ({ year, setYear }) => {
  const vars = [
    { value: "2021", label: "2021" },
    { value: "2022", label: "2022" },
    { value: "2023", label: "2023" },
    { value: "2024", label: "2024" },
    { value: "2025", label: "2025" },
    { value: "2026", label: "2026" }
  ];

  function handleChange(selectedOption) {
    setYear(selectedOption);
  }

  return (
    <Select
      className="selector"
      value={year}
      onChange={handleChange}
      // onBlur={handleChange}
      options={vars}
    />
  );
};

export default SelectYear;
